import * as types from "./actionTypes.js";
import * as resourceApi from '../../api/resourceApi.js';

/**
 * Finds an array of resources based on either the user name or sso. If an array is found it will dispatch a successful type. If not it will throw an error.
 * @param {*} name
 * @param {*} sso
 */
export function fetchFindResource(name, sso, withDisabled) {
  return function(dispatch) {
    withDisabled == undefined ? withDisabled = false: withDisabled = withDisabled;
    return resourceApi
      .getFindResource(name, sso, withDisabled)
      .then(resources => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_FIND_RESOURCE_SUCCESS,
          resources
        });
      })
      .catch(error => {
        throw error;
      });
  };
}
/**
 * Dispatches an updated resource when the user selects a different resource.
 * @param {*} resourceId
 * @param {*} resourceName
 */
export function updateSelectedResource(resourceId, resourceName) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_SELECTED_RESOURCE,
      selectedResource: {
        id: resourceId,
        name: resourceName
      }
    });
  };
}

export function updateSelectedDayTypeResource(resourceId, resourceName) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_SELECTED_DAY_TYPE_RESOURCE,
      selectedDayTypeResource: {
        id: resourceId,
        name: resourceName
      }
    });
  };
}

export function fetchResourcePersonnelData(resourceId) {
  return function(dispatch) {
    return resourceApi
      .getResourcePersonnelData(resourceId)
      .then(resourcePersonnelData => {
        // separate action creator for successfull api call
         dispatch({
          type: types.FETCH_RESOURCE_PERSONNEL_DATA_SUCCESS,
          resourcePersonnelData
         })
      })
      .catch(error => {
        throw error;
      });
  }
}

export function fetchResourceByDates(parameters) {
  return function(dispatch) {
    return resourceApi
      .getResourceByDates(parameters)
      .then(resourceByDates => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RESOURCE_BY_DATES_SUCCESS,
          resourceByDates
        })
      })
      .catch(error => {
        throw error;
      });
  }
}

export function fetchResourceContactInfo(parameters) {
  return function(dispatch) {
    return resourceApi
      .getResourceContactInfo(parameters)
      .then(resourceContactInfo => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RESOURCE_CONTACT_INFO,
          resourceContactInfo
        })
      })
      .catch(error => {
        throw error;
      });
  }
}
